import { render } from "./DescargaComponente.vue?vue&type=template&id=a3568a8a&scoped=true"
import script from "./DescargaComponente.vue?vue&type=script&lang=js"
export * from "./DescargaComponente.vue?vue&type=script&lang=js"

import "./DescargaComponente.vue?vue&type=style&index=0&id=a3568a8a&scoped=true&lang=css"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3568a8a"]])

export default __exports__